import { render, staticRenderFns } from "./SpeakersIframe.vue?vue&type=template&id=0f13a904&scoped=true&"
import script from "./SpeakersIframe.vue?vue&type=script&lang=js&"
export * from "./SpeakersIframe.vue?vue&type=script&lang=js&"
import style0 from "./SpeakersIframe.vue?vue&type=style&index=0&id=0f13a904&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f13a904",
  null
  
)

export default component.exports